import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.css']
})
export class ThankYouComponent implements OnInit {

  constructor( private title : Title ) { }

  ngOnInit(): void {
    this.title.setTitle('Payment Success | Resiliencesoft')
  }

}
